export const measurementsIt: Record<string, string> = {
  'track_version_customer_measurements': 'Traccia e versiona le misure dei clienti',
  'new_measurements': 'Nuove Misure',
  'create_new_measurement_set': 'Crea Nuovo Set di Misure',
  'select_customer_placeholder': 'Seleziona un cliente',
  'measurement_notes_placeholder': 'Note aggiuntive sulle misure, modifiche necessarie, ecc.',
  'select_customer_label': 'Seleziona Cliente',
  'compare_mode': 'Modalità Confronto',
  'previous_version': 'Versione Precedente',
  'current_version': 'Versione Corrente',
  'shoulder_width_back': 'Larghezza Spalle (dietro)',
  'waist_length_back': 'Lunghezza Vita (dietro)',
  'waist_length_front': 'Lunghezza Vita (davanti)',
  'bust_circumference': 'Circonferenza Seno',
  'waist_circumference': 'Circonferenza Vita',
  'hip_circumference': 'Circonferenza Fianchi',
  'bust_height': 'Altezza Seno',
  'distance_between_breasts': 'Distanza tra i Seni',
  'abdomen_circumference': 'Circonferenza Addome',
  'arm_circumference': 'Circonferenza Braccio',
  'wrist_circumference': 'Circonferenza Polso',
  'chest_circumference': 'Circonferenza Torace',
  'hip_upper': 'Fianchi Superiori',
  'shoulder': 'Spalla',
  'sleeve_length': 'Lunghezza Manica',
  'skirt_length': 'Lunghezza Gonna',
  'height': 'Altezza',
  'bust': 'Seno',
  'waist': 'Vita',
  'hips': 'Fianchi',
  'measurement_created_successfully': 'Set di misure creato con successo',
  'failed_to_create_measurement': 'Impossibile creare il set di misure',
  'failed_to_fetch_measurements': 'Impossibile recuperare le misure',

  // Namespaced measurements keys
  'measurements.title': 'Misure',
  'measurements.subtitle': 'Traccia e versiona le misure dei clienti',
  'measurements.selectCustomer': 'Seleziona Cliente',
  'measurements.details': 'Dettagli',
  'measurements.selectCustomerToView': 'Seleziona un cliente per visualizzare le misure',
  'measurements.recentMeasurements': 'Misure Recenti',
  'measurements.version': 'Versione',
  'measurements.newMeasurements': 'Nuove Misure',
  'measurements.createNewSet': 'Crea Nuovo Set di Misure',
  'measurements.saveMeasurements': 'Salva Misure',
  'measurements.notesPlaceholder': 'Note aggiuntive sulle misure, modifiche necessarie, ecc.',
  'measurements.photoDocumentationSoon': 'Documentazione fotografica in arrivo',
  'measurements.uploadPhotos': 'Carica Foto',
  'measurements.measuredOn': 'Misurato il',
  'measurements.history': 'Storico',
  'measurements.shoulderWidthBack': 'Larghezza Spalle (Dietro)',
  'measurements.waistLengthBack': 'Lunghezza Vita (Dietro)',
  'measurements.waistLengthFront': 'Lunghezza Vita (Davanti)',
  'measurements.bustHeight': 'Altezza Seno',
  'measurements.distanceBetweenBreasts': 'Distanza Tra i Seni',
  'measurements.shoulder': 'Spalla',
  'measurements.armCircumference': 'Circonferenza Braccio',
  'measurements.wristCircumference': 'Circonferenza Polso',
  'measurements.sleeveLength': 'Lunghezza Manica',
  'measurements.chestCircumference': 'Circonferenza Petto',
  'measurements.bustCircumference': 'Circonferenza Seno',
  'measurements.waistCircumference': 'Circonferenza Vita',
  'measurements.hipCircumference': 'Circonferenza Fianchi',
  'measurements.abdomenCircumference': 'Circonferenza Addome',
  'measurements.hipUpper': 'Fianchi (Superiori)',
  'measurements.skirtLength': 'Lunghezza Gonna',
  'measurements.height': 'Altezza',
  'measurements.noMeasurementsFound': 'Nessuna misurazione trovata per questo cliente',
  'measurements.noMeasurementsRecorded': 'Nessuna misurazione registrata ancora',
  'measurements.hideComparison': 'Nascondi Confronto',
  'measurements.comparePrevious': 'Confronta Precedente',
  'measurements.compare': 'Confronta',
  'measurements.comparingWithVersion': 'Confronto con Versione',
  'measurements.success.saved': 'Misure salvate con successo',
  'measurements.by': 'di',
  'measurements.errors.loadFailed': 'Impossibile caricare le misure',
  'measurements.errors.selectCustomer': 'Selezionare un cliente',
  'measurements.errors.saveFailed': 'Impossibile salvare le misure',
  'measurements.dialog.title': 'Dettagli Misure - Versione {version}',
  'measurements.dialog.photoTab': 'Foto',
  'measurements.dialog.coreBodyMeasurements': 'Misure Corpo Principali',
  'measurements.dialog.circumferenceMeasurements': 'Misure di Circonferenza',
  'measurements.dialog.lengthMeasurements': 'Misure di Lunghezza',
  'measurements.dialog.detailMeasurements': 'Misure di Dettaglio',
  'measurements.dialog.measurementInformation': 'Informazioni Misurazione',
  'measurements.dialog.versionBadge': 'Versione {version}',
  'measurements.dialog.takenOn': 'Rilevata il:',
  'measurements.dialog.measuredBy': 'Misurata da:',
  'measurements.dialog.measurementPhoto': 'Foto Misurazione',
  'measurements.dialog.measurementReferenceAlt': 'Riferimento misurazione',
  'measurements.dialog.noPhotoAvailable': 'Nessuna foto disponibile',
};
